"use client";
import { Inter } from "next/font/google";
import "@/app/globals.scss";
import { useTheme } from "@/context"; // Ensure useTheme is correctly set up to manage theme context
import { useEffect, useState } from "react";
import { FormProvider } from "@/context/FormContext";
import { useAuth } from "@/context/AuthContext";
import { useLanguageContext } from "@/context/LanguageContext";

const inter = Inter({ subsets: ["latin"] });

export default function LayoutBody({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const { darkMode } = useTheme();
  const { userDetails } = useAuth();
  const [title, setTitle] = useState<string>("");
  const { languageText } = useLanguageContext();
  const productPortalTitle = languageText?.PAGE_TITLES?.TJ_PRODUCT_PORTAL;
  const vendorPortalTitle = languageText?.PAGE_TITLES?.TJ_VENDOR_PORTAL;

  // Effect to handle theme toggling
  useEffect(() => {
    const body = document.body;

    // Clear existing theme classes
    body.classList.remove("dark-theme", "dark", "bg-TJ-Dark", "light-theme", "light");

    // Apply the selected theme
    if (darkMode) {
      body.classList.add("dark-theme", "dark", "bg-TJ-Dark");
    } else {
      body.classList.add("light-theme", "light");
    }
  }, [darkMode]);

  useEffect(() => {
    const role = userDetails?.roles?.[0]?.rolename?.split("|")?.[0];
    if (role === "VENDOR") {
      setTitle(vendorPortalTitle);
    } else {
      setTitle(productPortalTitle);
    }
  }, [userDetails]);

  // Set document title dynamically
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  return (
    <FormProvider>
      {children}
    </FormProvider>
  );
}
